import React from 'react';
import './App.css';
import 'animate.css';
import Main from './Components/Main/Main';

function App() {
  return (
    <>
      <Main />
    </>
  );
}

export default App;
